import { useEffect, useRef } from 'react';
import { useGlobalContext } from '../components/GlobalContextProvider/GlobalContextProvider';
import {
  CUSTOM_SECTION_TYPE,
  TABLE_TYPE,
  SUBSECTION_TYPE,
} from '../consts/content-types';
import removeHtmlTags from '../utils/removeHtmlTags';

function useSendIsContentCroppedToGTM(
  contents,
  restrictionType,
  pressType = null,
) {
  const didMount = useRef(false);
  const { user, contentView, setIsContentCropped } = useGlobalContext();

  useEffect(() => {
    if (!contents) {
      return;
    }

    let contentCropped;

    if (pressType) {
      if (pressType === 'news') {
        contentCropped = removeHtmlTags(contents.story).endsWith('...');
      }
      if (pressType === 'report') {
        contentCropped = removeHtmlTags(contents.report).endsWith('...');
      }
    } else {
      const el = contents[contents.length - 1] || {};
      if (el?.type === CUSTOM_SECTION_TYPE) {
        const { body } = el.value;

        if (body[body.length - 1].type === TABLE_TYPE) {
          contentCropped = false;
          return;
        }

        if (body.type === SUBSECTION_TYPE) {
          contentCropped = removeHtmlTags(
            body[body.length - 1].value.content,
          ).endsWith('...');
        } else {
          contentCropped = removeHtmlTags(body[body.length - 1].value).endsWith(
            '...',
          );
        }
      } else {
        const { value } = el;
        if (Array.isArray(value) && value.length > 0) {
          if (value[value.length - 1].type === SUBSECTION_TYPE) {
            contentCropped = removeHtmlTags(
              value[value.length - 1].value.content,
            ).endsWith('...');
          } else {
            contentCropped = removeHtmlTags(
              value[value.length - 1].value,
            ).endsWith('...');
          }
        } else if (value?.type === SUBSECTION_TYPE) {
          contentCropped = removeHtmlTags(value.value.content).endsWith('...');
        } else if (value) {
          contentCropped = removeHtmlTags(value).endsWith('...');
        }
      }
    }

    setIsContentCropped(contentCropped);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'pageView',
      contentView,
      restrictionType,
    });

    if (!didMount.current && user) {
      didMount.current = true;
      return;
    }
    didMount.current = true;
    window.dataLayer.push({
      event: 'pageFullyLoaded',
    });
    window.dataLayer.push({
      event: 'isContentCropped',
      isContentCropped: contentCropped,
    });
  }, [contents]);
}

export default useSendIsContentCroppedToGTM;
